mzFloatingTools = {
  init: function () {
    const components = document.querySelectorAll('.mz-floating-tools');

      components.forEach(component => {
        const openBtn = component.querySelector('.mz-floating-tools__open-btn');
        const closeBtn = component.querySelector('.mz-floating-tools__close-btn');
        const modal = component.querySelector('.mz-floating-tools__modal');
        const content = component.querySelector('.mz-floating-tools__content');
        const overlayBlanket = component.querySelector('.mz-floating-tools__blanket');

		gsap.from(openBtn, {
			delay:3,
		 	y:'+=110px'
		});

        openBtn.addEventListener('click', () => {
          component.classList.replace('closed', 'opening');

          gsap.to(openBtn, {
            height: `${content.clientHeight}px`,
            width: `${content.clientWidth}px`,
            duration: 0.3,
            backgroundColor: '#ffffff',
            onComplete: () => {
              component.classList.replace('opening', 'opened');
            },
          });

          modal.setAttribute('aria-hidden', false);
        });

        closeBtn.addEventListener('click', () => this.closeTools(component, modal, openBtn));
        overlayBlanket.addEventListener('click', () => this.closeTools(component, modal, openBtn));
      });
  },
  closeTools: function (component, modal, openBtn) {
    if (component.classList.contains('opening')) return;

    modal.setAttribute('aria-hidden', true);
    component.classList.replace('opened', 'closing');

    gsap.to(openBtn, {
      height: '50px',
      width: '50px',
      duration: 0.2,
      backgroundColor: '#910A2D',
      onComplete: () => {
        component.classList.replace('closing', 'closed');
      },
    });
  }
};

mzFunc.waitForEl('.mz-floating-tools').then(function () { mzFloatingTools.init(); });